import DetailsPanel from './DetailsPanel.component';
export default DetailsPanel;